export const environment = {
	name: 'qa',
	production: false,
	//apiBaseUrl: 'https://paxi-express-api-gateway-chx1a42g.ew.gateway.dev',
	apiBaseUrl: 'https://express-api-qa.paxi.co.za',
	apiKey: 'AIzaSyCooLQW8GSJSq9ZoBtajX0vOKieg7bOvV8',
	firebaseConfig: {
		apiKey: "AIzaSyB_4OSsY401V2KhOAHI-kYoKFgGxdPtR5I",
		authDomain: "grp-serv-digi-test-paxi.firebaseapp.com",
		projectId: "grp-serv-digi-test-paxi",
		storageBucket: "grp-serv-digi-test-paxi.appspot.com",
		messagingSenderId: "979372804120",
		appId: "1:979372804120:web:6fc1adf55c02e8de14db6d",
		measurementId: "G-H57YH8D5E5"
	},
};
